/* @flow */

/**
 * UserOnly
 *
 * Redirects anonymous users to the landing page
 */

import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Loader from '../commons/Loader';

type Props = {
  goLogin?: boolean,
  disabled?: boolean,
  children: any,
  hasInitialised: boolean,
  history: Object,
  isFetchingUser: boolean,
  isSignedIn: boolean
};

const defaultProps = {
  goLogin: false,
  disabled: false
};

class UserOnly extends React.Component<Props> {
  props: Props;

  componentDidMount() {
    const { goLogin, history, isFetchingUser, isSignedIn, hasInitialised } = this.props;
    if (!isSignedIn && goLogin) {
      if (window.portal) window.portal.client.showLogin();
      return;
    }

    if (hasInitialised && !isSignedIn && !isFetchingUser) {
      history.push('/');
    }
  }

  componentDidUpdate(prevProps: Props) {
    const { history, isSignedIn, hasInitialised, isFetchingUser } = this.props;
    if (hasInitialised && !isFetchingUser && !isSignedIn && prevProps.isSignedIn) {
      history.push('/');
    }
  }

  render() {
    const { children, isSignedIn, disabled } = this.props;
    if (!disabled && !isSignedIn) {
      return <Loader />;
    }
    return children;
  }
}

function mapStateToProps(state, { goLogin, history }) {
  return {
    goLogin,
    hasInitialised: state.user.hasInitialised,
    isFetchingUser: state.user.fetchingUserData,
    isSignedIn: state.user.isSignedIn,
    history
  };
}

UserOnly.defaultProps = defaultProps;

export default withRouter(connect(mapStateToProps, {})(UserOnly));
